<template>
    <transition name="fade">
        <div
            v-if="visible"
            class="confirm-dialog"
        >
            <div class="dialog">
                <h3 class="dialog-title">{{ title }}</h3>
                <p class="dialog-content">{{ content }}</p>
                <div class="dialog-buttons">
                    <div
                        @click="cannel"
                        class="dialog-button cannel"
                    >
                        {{ cancelButtonText }}
                    </div>
                    <div
                        @click="confirm"
                        class="dialog-button confirm"
                    >
                        {{ confirmButtonText }}
                    </div>
                </div>
            </div>
        </div>
    </transition>
  </template>

<script>

export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      title: '',
      content: '',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    };
  },
  methods: {
    show(resolve, reject) {
      this.resolve = resolve;
      this.reject = reject;
      this.visible = true;
    },
    cannel() {
      this.reject && this.reject('cannel');
      this.close();
    },
    confirm() {
      this.resolve && this.resolve('confirm');
      this.close();
    },
    close() {
      this.visible = false;
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
  },
};
</script>

<style lang="less" scoped>
.confirm-dialog {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 600;
    background-color: rgba(0, 0, 0, 0.5);
    .dialog {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 328px;
        border-radius: 12px;
        background-color: #fff;
        padding: 24px;
        &-title {
            color: @black;
            font-size: @fontMedium;
            font-weight: 700;
            line-height: 24px;
            margin-bottom: 16px;
        }
        &-content {
            color: @black;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 32px;
        }
        &-buttons {
          display: flex;
          justify-content: space-between;
          .dialog-button {
            width: 132px;
            height: 44px;
            line-height: 44px;
            border-radius: 22px;
            text-align: center;
            background-color: rgba(13, 13, 13, 0.06);
            font-size: 16px;
            color: @black;
            &.confirm {
              background-color: @theme;
              color: #fff;
            }
          }
        }
    }
}

</style>
